module.exports = __webpack_public_path__ + "static/media/headimage2.11b4fa47.jpg";